var map = {
  "./action.svg": "68640",
  "./address.svg": "31608",
  "./all-forms-legacy.svg": "10257",
  "./all-forms.svg": "23881",
  "./api.svg": "71360",
  "./approvals.svg": "39960",
  "./archive-open.svg": "87475",
  "./archive.svg": "26370",
  "./arrow-left.svg": "39055",
  "./arrow-right.svg": "55994",
  "./audit-log.svg": "90184",
  "./automation.svg": "12637",
  "./ban.svg": "82401",
  "./bold.svg": "46509",
  "./bug fix.svg": "75129",
  "./bug-fix.svg": "30184",
  "./build.svg": "97264",
  "./bulk-actions.svg": "4616",
  "./calculations.svg": "18808",
  "./center.svg": "19911",
  "./check.svg": "53684",
  "./chevron-down.svg": "90680",
  "./chevron-left.svg": "6765",
  "./chevron-right.svg": "97544",
  "./chevron-up.svg": "29309",
  "./choice.svg": "7049",
  "./circle.svg": "65130",
  "./clear-fields.svg": "50587",
  "./cog.svg": "16471",
  "./cognibot.svg": "61337",
  "./collapse-menu.svg": "31945",
  "./columns.svg": "66607",
  "./continue-workflow.svg": "62849",
  "./copy.svg": "77355",
  "./create-document.svg": "98366",
  "./create-entries.svg": "58619",
  "./credit-card.svg": "89894",
  "./currency.svg": "61185",
  "./cut.svg": "20992",
  "./data.svg": "84042",
  "./date.svg": "79910",
  "./double-chevron-left.svg": "37987",
  "./double-chevron-right.svg": "84678",
  "./download.svg": "44790",
  "./drag-handle-dot.svg": "99225",
  "./drag-handle.svg": "81075",
  "./edit-profile.svg": "74218",
  "./edit-square.svg": "58924",
  "./edit.svg": "21198",
  "./ellipsis.svg": "27193",
  "./email.svg": "89304",
  "./entries.svg": "2176",
  "./error.svg": "53138",
  "./ex-outline.svg": "96592",
  "./ex.svg": "17239",
  "./external-link.svg": "1314",
  "./eye.svg": "19285",
  "./facebook.svg": "92182",
  "./field-above.svg": "14328",
  "./field-below.svg": "23940",
  "./field-left.svg": "89520",
  "./field-right.svg": "41979",
  "./filter.svg": "88300",
  "./flask.svg": "64119",
  "./floating.svg": "59000",
  "./folder.svg": "8726",
  "./form-view.svg": "67836",
  "./form.svg": "51280",
  "./generated-documents.svg": "83850",
  "./github.svg": "13817",
  "./give-access.svg": "35546",
  "./grid.svg": "56398",
  "./hamburger.svg": "16067",
  "./home.svg": "97745",
  "./hr.svg": "62976",
  "./image.svg": "3073",
  "./indent.svg": "89968",
  "./infinity.svg": "2466",
  "./info.svg": "35526",
  "./instagram.svg": "65316",
  "./internal.svg": "77235",
  "./italic.svg": "74174",
  "./justify field.svg": "41544",
  "./justify.svg": "71140",
  "./left.svg": "60995",
  "./light-bulb.svg": "98222",
  "./limited-availability.svg": "18640",
  "./link.svg": "93342",
  "./linkedin.svg": "42824",
  "./loading.svg": "76804",
  "./lock.svg": "429",
  "./login.svg": "68273",
  "./logout.svg": "39556",
  "./lookup.svg": "25532",
  "./minus-square.svg": "63242",
  "./mobile-phone.svg": "8885",
  "./mouse-click.svg": "10770",
  "./multiple-emails.svg": "9882",
  "./name.svg": "76681",
  "./no-eye.svg": "85937",
  "./number.svg": "54011",
  "./ol.svg": "3041",
  "./open-folder.svg": "78967",
  "./organization.svg": "69621",
  "./outdent.svg": "49929",
  "./page-break.svg": "46619",
  "./paste.svg": "74727",
  "./pdf.svg": "25690",
  "./pending.svg": "30491",
  "./person.svg": "3495",
  "./phone.svg": "7464",
  "./pin.svg": "4579",
  "./plus-square.svg": "29820",
  "./plus.svg": "65790",
  "./preview.svg": "91804",
  "./price.svg": "11005",
  "./print.svg": "13171",
  "./public-link-disabled.svg": "33041",
  "./public-link.svg": "71308",
  "./public.svg": "15263",
  "./rating-scale.svg": "53096",
  "./read-unread.svg": "84220",
  "./recent.svg": "44393",
  "./refund.svg": "97568",
  "./register.svg": "41319",
  "./repeating-section.svg": "86487",
  "./reset.svg": "86811",
  "./resize.svg": "57242",
  "./retrying.svg": "62236",
  "./right.svg": "17702",
  "./role.svg": "51254",
  "./save-resume.svg": "98495",
  "./save.svg": "78703",
  "./search.svg": "6018",
  "./section.svg": "74879",
  "./sending.svg": "38410",
  "./settings.svg": "46679",
  "./share-role.svg": "67640",
  "./share.svg": "96499",
  "./shared-template.svg": "57338",
  "./sidebar.svg": "19892",
  "./signature.svg": "65726",
  "./sort-down.svg": "46371",
  "./sort-up.svg": "43166",
  "./sort.svg": "22090",
  "./spreadsheet-spark.svg": "41898",
  "./star-outline.svg": "91281",
  "./star.svg": "29518",
  "./stop-sign.svg": "87142",
  "./style-body-1.svg": "57664",
  "./style-body.svg": "3426",
  "./style-header.svg": "85755",
  "./style-page.svg": "67577",
  "./style.svg": "47253",
  "./success.svg": "11863",
  "./support.svg": "21471",
  "./sync.svg": "85693",
  "./table.svg": "59972",
  "./task-grid.svg": "62824",
  "./tasks.svg": "11042",
  "./textbox.svg": "43540",
  "./theme.svg": "76133",
  "./time.svg": "97259",
  "./trash.svg": "78486",
  "./ul.svg": "40547",
  "./underline.svg": "27972",
  "./unpin.svg": "63938",
  "./upload.svg": "91655",
  "./users.svg": "64264",
  "./video.svg": "2871",
  "./warning.svg": "39628",
  "./watch.svg": "23251",
  "./webhooks.svg": "97940",
  "./word.svg": "52750",
  "./workflow.svg": "43363",
  "./x.svg": "70960",
  "./yes-no.svg": "82887",
  "./youtube.svg": "94937"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 53899;
